<template>
  <section class="w-90 ma-auto">
    <carousel :items="3" dir="ltr" :autoplay="true" :nav="false">
      <div class="d-flex align-center justify-center pa-4"  v-for="(item,i) in certificate" :key="i">
        <v-card
            max-width="380"
        >
          <v-img
              :src="item.image"
              height="200px"
          ></v-img>

          <v-card-title>
            {{item.title}}
          </v-card-title>

          <v-card-subtitle>
            {{item.subTitle}}
          </v-card-subtitle>

          <v-card-actions>


            <v-spacer></v-spacer>


          </v-card-actions>

          <v-expand-transition>
            <div>


              <v-card-text>
                {{item.details}}
              </v-card-text>
            </div>
          </v-expand-transition>
        </v-card>
      </div>


    </carousel>
<!--    <v-slide-group show-arrows v-model="slider">
      <v-slide-item  v-for="(item,i) in certificate" :key="i">
        <v-card
            class="mx-3"
            max-width="344"
        >
          <v-img
              :src="item.image"
              height="200px"
          ></v-img>

          <v-card-title>
           {{item.title}}
          </v-card-title>

          <v-card-subtitle>
           {{item.subTitle}}
          </v-card-subtitle>

          <v-card-actions>


            <v-spacer></v-spacer>


          </v-card-actions>

          <v-expand-transition>
            <div>
              <v-divider></v-divider>

              <v-card-text>
                {{item.details}}
              </v-card-text>
            </div>
          </v-expand-transition>
        </v-card>
      </v-slide-item>
    </v-slide-group>-->
    <div>

    </div>
  </section>
</template>
<script>
import carousel from 'vue-owl-carousel'
export default {
  name: 'certificate',
  components:{carousel},
  data(){
    return{
      slider:null,
      certificate:[
        {
          title:'گواهینامه',
          subTitle:'استاندارد های لازم',
          details:'بزرگ‌ترین خط تولید شیشه فلوت در خاورمیانه و تولید انواع شیشه از ضخامت 1.8mm تا 19mm بزرگ‌ترین خط تولید شیشه فلوت در خاورمیانه و تولید انواع شیشه از ضخامت 1.8mm تا 19mm',
          image:require('../../../../assets/images/product-images/karbonat-sodium.jpg'),
        },
        {
          title:'گواهینامه',
          subTitle:'استاندارد های لازم',
          details:'بزرگ‌ترین خط تولید شیشه فلوت در خاورمیانه و تولید انواع شیشه از ضخامت 1.8mm تا 19mm بزرگ‌ترین خط تولید شیشه فلوت در خاورمیانه و تولید انواع شیشه از ضخامت 1.8mm تا 19mm',
          image:require('../../../../assets/images/product-images/malat.jpg'),
        },
        {
          title:'گواهینامه',
          subTitle:'استاندارد های لازم',
          details:'بزرگ‌ترین خط تولید شیشه فلوت در خاورمیانه و تولید انواع شیشه از ضخامت 1.8mm تا 19mm بزرگ‌ترین خط تولید شیشه فلوت در خاورمیانه و تولید انواع شیشه از ضخامت 1.8mm تا 19mm',
          image:require('../../../../assets/images/product-images/masse.jpg'),
        },
        {
          title:'گواهینامه',
          subTitle:'استاندارد های لازم',
          details:'بزرگ‌ترین خط تولید شیشه فلوت در خاورمیانه و تولید انواع شیشه از ضخامت 1.8mm تا 19mm بزرگ‌ترین خط تولید شیشه فلوت در خاورمیانه و تولید انواع شیشه از ضخامت 1.8mm تا 19mm',
          image:require('../../../../assets/images/product-images/float-glass.jpg'),
        },
        {
          title:'گواهینامه',
          subTitle:'استاندارد های لازم',
          details:'بزرگ‌ترین خط تولید شیشه فلوت در خاورمیانه و تولید انواع شیشه از ضخامت 1.8mm تا 19mm بزرگ‌ترین خط تولید شیشه فلوت در خاورمیانه و تولید انواع شیشه از ضخامت 1.8mm تا 19mm',
          image:require('../../../../assets/images/product-images/karbonat-sodium.jpg'),
        },
        {
          title:'گواهینامه',
          subTitle:'استاندارد های لازم',
          details:'بزرگ‌ترین خط تولید شیشه فلوت در خاورمیانه و تولید انواع شیشه از ضخامت 1.8mm تا 19mm بزرگ‌ترین خط تولید شیشه فلوت در خاورمیانه و تولید انواع شیشه از ضخامت 1.8mm تا 19mm',
          image:require('../../../../assets/images/product-images/karbonat-sodium.jpg'),
        },

      ]
    }
  }
}
</script>
<style scoped>
.one h1 {
  text-align: center;
  text-transform: uppercase;
  padding-bottom: 5px;
}
</style>